import "../../../../chunk-D57E6H3M.mjs";

// src/components/composite/Timeline/shared/unfold.ts
import { useLayoutEffect, useRef } from "react";
var PROPERTIES = ["from-width", "from-height", "to-width", "to-height", "content-width", "from-opacity", "delay"].map((name) => `--buyscout-unfold-${name}`);
function settle(element) {
  element.removeAttribute("data-unfolding");
  for (const property of PROPERTIES) element.style.removeProperty(property);
}
var sum = (values) => values.reduce((total, value) => total + (Number.parseFloat(value) || 0), 0);
function boxOf(element) {
  const style = getComputedStyle(element);
  const width = Number.parseFloat(style.width);
  const height = Number.parseFloat(style.height);
  if (Number.isNaN(width) || Number.isNaN(height)) return { width: element.offsetWidth, height: element.offsetHeight };
  if (style.boxSizing === "border-box") return { width, height };
  return {
    width: width + sum([style.paddingLeft, style.paddingRight, style.borderLeftWidth, style.borderRightWidth]),
    height: height + sum([style.paddingTop, style.paddingBottom, style.borderTopWidth, style.borderBottomWidth])
  };
}
function unfold(element, from, { delay = "0ms", fade = false } = {}) {
  settle(element);
  if (window.matchMedia?.("(prefers-reduced-motion: reduce)").matches) return;
  const to = boxOf(element);
  if (!fade && Math.abs(to.width - from.width) < 1 && Math.abs(to.height - from.height) < 1) return;
  const { paddingLeft, paddingRight, borderLeftWidth, borderRightWidth } = getComputedStyle(element);
  const contentWidth = to.width - sum([paddingLeft, paddingRight, borderLeftWidth, borderRightWidth]);
  const values = [from.width, from.height, to.width, to.height, contentWidth].map((value) => `${value}px`);
  values.push(fade ? "0" : "1", delay);
  PROPERTIES.forEach((property, index) => element.style.setProperty(property, values[index]));
  element.setAttribute("data-unfolding", "");
  element.setAttribute("data-unfolded", "");
  element.addEventListener("animationend", function done(event) {
    if (event.target !== element || event.animationName !== "buyscout-unfold") return;
    element.removeEventListener("animationend", done);
    settle(element);
  });
}
function useUnfold(ref, phase) {
  const boxRef = useRef(null);
  const phaseRef = useRef(phase);
  useLayoutEffect(() => {
    const element = ref.current;
    if (element && boxRef.current && phaseRef.current !== phase) unfold(element, boxRef.current);
    phaseRef.current = phase;
    boxRef.current = element ? boxOf(element) : null;
  });
}
export {
  boxOf,
  unfold,
  useUnfold
};
//# sourceMappingURL=unfold.mjs.map